import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { ContactBalanceTransactionExportCommandHandler } from './export-contact-balance-transaction-command-handler.service';
import { ContactBalanceTransactionCommand } from '../../command/contact-balance-transaction';

@Injectable()
export class ContactBalanceTransactionCommandHandlerResolver extends CommandHandlerResolver {
  constructor(contactBalanceTransactionExportHandler: ContactBalanceTransactionExportCommandHandler) {
    super();
    this.addHandler(ContactBalanceTransactionCommand.export, contactBalanceTransactionExportHandler);
  }
}
